var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"d-block text-center",attrs:{"fixed":"","height":"50"}},[_vm._v(" "+_vm._s(_vm.appName)+" - v"+_vm._s(_vm.appVersion)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }